<template>
  <div>
    <div class="invoices">
      <div class="w3-container">
        <div class="headerGrid">
          <div>
            <header>
              <h2>Add Subscription</h2>
            </header>
          </div>
          <div>
            <router-link to="/subscriptions" class="w3-button w3-red w3-small w3-right vmiddle">
              <i class="fas fa-times" style="margin-right:8px;"></i>Cancel
            </router-link>
            <button @click="saveSub()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
              <i class="fas fa-save" style="margin-right:8px;"></i>Save
            </button>
          </div>
        </div>

        <div class="details">
          <div>
            <div class="w3-white outline">
              <header class="light outline">
                <h5>Bill To</h5>
              </header>
              <div class="w3-padding">
                <div class="w3-bar-block">
                  <v-select class="w3-select" style="border:0; padding:0; margin-top:6px;" v-model="newSub.client" label="name" :options="state.admin.global.clients.list">
                    <template slot="option" slot-scope="option">
                      <p>
                        {{ option.name }}<br/>
                        {{ option.email }}<br/>
                        {{ option.company }}
                      </p>
                    </template>
                  </v-select>
                  <div class="w3-bar-item" v-if="newSub.client.name !== 'Choose Client'">
                    {{newSub.client.company}}<br/>
                    {{newSub.client.name}}<br/>
                    {{newSub.client.email}}<br/>
                    {{newSub.client.address1}}<br/>
                    <span v-if="newSub.client.address2 !== ''">{{newSub.client.address2}}<br/></span>
                    <span>{{newSub.client.city}}, </span><span>{{newSub.client.state}}&nbsp;&nbsp;</span><span>{{newSub.client.zipcode}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="w3-white outline w3-margin-top">
              <header class="light outline">
                <h5>Start Date</h5>
              </header>
              <date-select v-on:set-start-date="setStartDate"></date-select>
            </div>
          </div>

          <div>
            <div class="w3-white outline">
              <header class="light outline">
                <h5>Services</h5>
              </header>
              <template v-if="newSub.plans.length">
                <div class="serviceTable" v-for="(item, key, i) in newSub.plans" :key="i">
                  <div class="w3-padding">
                    {{item.productName}} - {{item.nickname}}
                  </div>
                  <div class="w3-padding">
                    {{item.metadata.domain}}
                  </div>
                  <div class="w3-padding w3-right-align">
                    {{item.amount / 100 | currency}} / {{item.interval}}
                  </div>
                  <div>
                    <button class="w3-button w3-red tableBtn" @click="removeItem(key)"><i class="fa fa-trash w3-small"></i></button>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="w3-padding">
                  No items. Add some using the product selector.
                </div>
              </template>
            </div>

            <div class="w3-margin-top">
              <header class="light outline headerGrid">
                <div>
                  <h5 class="comfortaa">Product Selector</h5>
                  <p>Add products to this subscription</p>
                </div>
              </header>

              <div class="w3-white">
                <div class="w3-padding-8 productGrid">
                  <div @click="product = item; productPlans()" class="w3-padding outline pointer vCenter" :class="product === item ? 'w3-black':''" v-for="(item, index) in state.admin.global.products.data" :key="index">
                    {{item.name}}
                  </div>
                </div>
                <div v-if="product.name !== ''">
                  <div class="divider"></div>
                  <div class="w3-padding-8 productGrid">
                    <div @click="plan = item" :class="plan === item ? 'w3-black':''" v-for="(item, index) in plans" :key="index">
                      <div v-if="item.nickname !== ''" class="w3-padding outline pointer vCenter">
                        {{item.nickname}}<br/>
                        {{item.amount / 100 | currency}} / {{item.interval}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w3-padding-8 w3-white" v-if="plan.nickname !== ''">
                <label class="w3-label">Associated Domain</label>
                <input class="w3-input w3-border" placeholder="mydomain.com" v-model="plan.domain" />
                <div class="w3-right-align w3-margin-top">
                  <button class="w3-button w3-green headerButton" @click="addItem()" :disabled="!plan.domain">add service</button>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore'
import dateSelect from './dateSelect'
import * as moment from 'moment'

export default {
  name: 'addInvoice',
  data() {
    return {
      state: dataStore.state,
      product: {
        name: ''
      },
      plan: {
        nickname: '',
        domain: ''
      },
      plans: [],
      newSub: {
        client: {
          name: 'Choose Client'
        },
        startDate: '',
        plans: [],
        planids: [],
        metadata: {},
        total: 0
      },
      error: {
        product: false,
        plan: false
      }
    }
  },
  components: {
    dateSelect
  },
  created() {
    dataStore.getAdminGlobalData()
  },
  methods: {
    addItem() {
      this.error.product = false
      this.error.plan = false
      if (this.product === {}) {
        this.error.product = true
      }
      if (this.plan === {}) {
        this.error.plan = true
      }
      if (this.product === {} && this.plan === {}) {
        this.error.product = true
        this.error.plan = true
        return
      }
      this.plan.productName = this.product.name
      this.newSub.plans.push(this.plan)
      this.newSub.planids.push({
        'plan': this.plan.id,
        'quantity': 1
      })
      this.newSub.total += this.plan.amount
      this.newSub.metadata[this.plan.id] = this.plan.domain
    },
    productPlans() {
      // console.log(this.state.admin.global.plans)
      this.plans = []
      for (let item of this.state.admin.global.plans.data) {
        if (this.product) {
          if (item.product === this.product.id) {
            this.plans.push(item)
          }
        }
      }
    },
    removeItem(key) {
      this.newSub.plans.splice(key, 1)
      this.newSub.planids.splice(key, 1)
      console.log(this.newSub.planids)
      // this.newSub.total -= this.newSub.items[key].amount
    },
    saveSub() {
      if (!this.newSub.client.stripeid) {
        console.log('no customer')
        return
      }
      if (!this.newSub.planids.length) {
        console.log('no items')
        return
      }
      let sub = {
        'customer': this.newSub.client.stripeid,
        'items': this.newSub.planids,
        'metadata': this.newSub.metadata
      }
      if (moment(this.newSub.startDate).isAfter(new Date(), 'day')) {
        sub['billing_cycle_anchor'] = moment(this.newSub.startDate).unix()
      }
      dataStore.saveSubscription(sub, true).then(result => {
        if (result.data.code === 'success') {
          this.$router.replace('/subscriptions')
        }
      })
    },
    setStartDate(value) {
      console.log(value)
      this.newSub.startDate = value
    }
  }
}
</script>

<style scoped>
.details {display:grid; grid-template-columns: 1fr 2fr; grid-gap: 8px;}
.w3-select {background:#fafafa; border:1px solid #ccc; border-radius:5px;}
.cardRight {margin:0 0 0 auto; display:block;}
.tableBtn {padding:4px 12px; font-size:0.9rem; margin-top:5px;}

/* .productSelect {} */
.productSelect:last-child {border-bottom:none;}
.productSelect:hover {background:#212121; color:#fff;}

.productContainerGrid {display:grid; grid-template-columns: 1fr; grid-gap: 8px;}
.productGrid {display:grid; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto; grid-gap: 8px; text-align:center;}
.vCenter {display:grid; align-items: center;}
.serviceTable {display:grid; grid-template-columns:2fr 1fr 155px 40px; grid-template-rows: 1fr;}

@media screen and (max-width:800px) {
  .lineText {width:80%;}
  .lineAmount {width:15%;}
}

@media screen and (max-width:600px) {
  .lineText {width:75%;}
  .lineAmount {width:20%;}
  .serviceTable {grid-template-columns: 2fr 2fr 1fr;}
}

</style>



// WEBPACK FOOTER //
// src/components/addSubscription.vue